module.exports = __webpack_public_path__ + "media/images/icon_consulting-99d203ee99f9becf7237399089980c55.svg";